export default {
    heroSlider: {
        pagination: 'default',
        effect: 'fade',
        loop: true,
        lazy: true,
        preloadImages: false
    },
    projectsSlider: {
        navigation: 'default',
        slidesPerView: 'auto',
        watchOverflow: true
    },
    partnersSlider: {
        pagination: 'default',
        lazy: true
    },
    projectsSliderAlt: {
        pagination: 'default',
        slidesPerView: 'auto',
        watchOverflow: true,
        // effect: 'fade',
        breakpoints: {
            1200: {
                slidesPerView: 3,
                slidesPerColumn: 2,
                slidesPerColumnFill: 'row',
                slidesPerGroup: 3,
                spaceBetween: '40px'
            }
        }
    },
};